import { DatasetUpdateShapeForm as Form } from './dataset-update-shape-form';
import { DatasetUpdateLayout as Layout } from './layout';

export function DatasetUpdateShape(props) {
	return (
		<Layout>
			<Form {...props} />
		</Layout>
	);
}

export * from './dataset-update-shape-form';
